<mat-card>
	<h3>
		Contact the RAILS administrator for access:
	</h3>
	<mat-list>
		<mat-list-item>
			<mat-icon mat-list-icon>account_circle</mat-icon>
			<h4 mat-line>{{ (administratorDetails$ | async)?.fullName }}</h4>
		</mat-list-item>
		<mat-list-item>
			<mat-icon mat-list-icon>email</mat-icon>
			<h4 mat-line>
				<a
					href="mailto:{{
						(administratorDetails$ | async)?.emailAddress
					}}"
				>
					{{ (administratorDetails$ | async)?.emailAddress }}
				</a>
			</h4>
		</mat-list-item>
		<mat-list-item>
			<mat-icon mat-list-icon>phone</mat-icon>
			<h4 mat-line>
				<a
					href="tel:{{
						(administratorDetails$ | async)?.phoneNumber
					}}"
				>
					{{ (administratorDetails$ | async)?.phoneNumber }}
				</a>
			</h4>
		</mat-list-item>
	</mat-list>
</mat-card>
